// MainLayout.jsx
import { Layout } from 'pink-lava-ui';
import type { ReactNode } from 'react';
import CustomSidebar from './Sidebar';
import CustomHeader from './Header';

const { Content } = Layout;

function MainLayout({ children }: { children: ReactNode }) {
  return (
    <Layout className="w-screen h-screen flex flex-row main-layout-container">
      <CustomSidebar />
      <Layout className="flex flex-col flex-1">
        <CustomHeader />
        <Content className="flex-1 overflow-y-auto overflow-x-hidden">{children}</Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
